import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9h18v-6h-18v18h6v-18","key":"svg-0"}],["path",{"d":"M3 15h12v-12","key":"svg-1"}]]

const IconChartCohort = createReactComponent('outline', 'chart-cohort', 'ChartCohort', __iconNode);

export default IconChartCohort;